import React, { useMemo, Suspense } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SpeakerNotesOffIcon from "@mui/icons-material/SpeakerNotesOff";

import { getUid } from "../../api/auth";
import { ACTIONS as CHAT_ACTIONS } from "../../redux/chat";
import NotFoundMessage from "../not-found-message";

import UserItem from "./user-item";
import StyledChatMenu from "./styles";

const ChatMenu = ({
  chats = {},
  loading,
  FallbackComponent,
  fallbackProps = {},
}) => {
  const dispatch = useDispatch();
  let chatList = [];

  if (chats) {
    chatList = Object.values(chats);
  }
  const { uid } = getUid();

  const params = useParams();
  const itemHeight = 70;
  const margin = 10;

  const { length, height, totalHeight } = useMemo(() => {
    const length = chatList?.length || 0;
    const height = length * (itemHeight + margin);
    const totalHeight = itemHeight + margin;
    return { length, height, totalHeight };
  }, [chatList, itemHeight, margin]);

  const showChatList = useMemo(() => {
    return chatList && chatList.length > 0;
  }, [chatList]);

  return (
    <StyledChatMenu>
      <div className="chat-menu" style={{ height: `${height}px` }}>
        {showChatList ? (
          chatList.map((item, i) => (
            <UserItem
              {...item}
              selected={params?.chatId === item.chatId}
              height={itemHeight}
              onClick={() => dispatch(CHAT_ACTIONS.openChat({ ...item }))}
              itemHeight={itemHeight}
              key={item.chatId}
              animatedStyles={{
                translateY: totalHeight * item.index,
              }}
              styles={{ zIndex: length - item.index }}
              read={item.lastMessage?.read?.[uid]}
            />
          ))
        ) : FallbackComponent ? (
          <FallbackComponent {...fallbackProps} />
        ) : null}
      </div>
    </StyledChatMenu>
  );
};

export default ChatMenu;
